module.exports = __webpack_public_path__ + "img/dfsyc.49377f3c.png";